var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "#1098fc",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9288 2.92132L13.3848 5.85698C13.5833 6.26564 14.1128 6.65762 14.5595 6.73267L17.1984 7.17469C18.886 7.45825 19.2831 8.69256 18.067 9.91019L16.0155 11.9785C15.668 12.3288 15.4777 13.0043 15.5853 13.488L16.1726 16.0484C16.6359 18.075 15.5687 18.859 13.7902 17.7998L11.3167 16.3236C10.87 16.0567 10.1337 16.0567 9.67872 16.3236L7.20524 17.7998C5.43492 18.859 4.3595 18.0667 4.82276 16.0484L5.4101 13.488C5.51765 13.0043 5.32738 12.3288 4.97993 11.9785L2.92835 9.91019C1.72057 8.69256 2.10938 7.45825 3.79697 7.17469L6.4359 6.73267C6.87434 6.65762 7.40378 6.26564 7.60232 5.85698L9.05828 2.92132C9.85244 1.32839 11.1429 1.32839 11.9288 2.92132Z"
  }))));
};
export default SvgStarFilled;